function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 45,
  r: 45,
  fill: "#FA6358",
  fillOpacity: 0.15
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M74.082 27.748h-21.98c-1.61.14-2.8 1.4-2.8 2.94v60.13c.14 1.61 1.4 2.8 2.94 2.8h21.77c1.61 0 2.94-1.33 2.94-2.94v-60.13c-.07-1.61-1.33-2.8-2.87-2.8zm-.91 62.09h-20.02v-2.59h4.55c1.05 0 1.96-.84 1.96-1.96s-.84-1.96-1.96-1.96h-4.55v-5.81h8.54c1.05 0 1.96-.84 1.96-1.96s-.84-1.96-1.96-1.96h-8.54v-5.95h4.62c1.05 0 1.89-.84 1.89-1.89 0-1.05-.84-1.96-1.89-1.96h-4.62v-5.74h8.54c1.05 0 1.96-.84 1.96-1.96s-.84-1.96-1.96-1.96h-8.54v-5.88h4.62c1.05 0 1.89-.91 1.89-1.96 0-1.05-.91-1.89-1.96-1.89h-4.62v-5.81l8.54-.07c1.05 0 1.89-.91 1.89-1.96 0-1.05-.84-1.89-1.89-1.89l-8.47.07v-3.15h20.02v58.24zm32.689-60.971c-.56-.56-1.26-.84-2.03-.84-4.13-.14-8.33-.21-12.53-.14-.84 0-1.61.28-2.17.77-.56.56-.91 1.26-.91 2.1l-.07 47.041v.42l7.35 14.84c.28.63.84 1.05 1.54 1.12h.35c.56 0 1.12-.21 1.54-.7l.21-.21 7.49-15.05.07-47.32c0-.77-.35-1.47-.84-2.03zm-3.01 2.94v7.63h-10.78v-7.7c3.57-.07 7.21 0 10.78.07zm-5.46 56.421l-4.27-8.47h.91c1.05 0 1.89-.84 1.89-1.96s-.84-1.89-1.96-1.89h-2.1l.14-32.62h10.78v32.62h-2.1c-1.05 0-1.89.84-1.89 1.96s.84 1.89 1.96 1.89h.91l-4.27 8.47z"
});

function SvgBenefit1Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 107 95"
  }, props), _ref, _ref2);
}

export default SvgBenefit1Inline;